import { type SortDirection, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'

interface Props {
  sortAttribute: string
  sortDirection: SortDirection
  onSort: (attribute: string, sortDirection: SortDirection) => void
  canEmployeeSeeAggregatedPersonalInfo: boolean
}

const Header = ({
  sortAttribute,
  sortDirection,
  onSort,
  canEmployeeSeeAggregatedPersonalInfo,
}: Props) => {
  const canSeeAggregatedInfo = canEmployeeSeeAggregatedPersonalInfo
  const hasWorkLocation = companies.current.attributes.has_clock_in_location_enabled
  return (
    <Table.Head>
      <Table.Row>
        <Table.SortableHeadCell
          colSpan={3}
          attribute="name"
          onSort={onSort}
          sortAttribute={sortAttribute}
          sortDirection={sortDirection}
        >
          {i18n.t('teams.name')}
        </Table.SortableHeadCell>
        <Table.HeadCell colSpan={1}>{i18n.t('employees.common.team_members')}</Table.HeadCell>
        {hasFeature('teams_insights') && (
          <>
            <Table.HeadCell colSpan={2}>{i18n.t('employees.common.averages')}</Table.HeadCell>
          </>
        )}
        {hasWorkLocation && (
          <Table.HeadCell colSpan={2}>
            <InformationTooltip
              information={i18n.t('teams.working_location_tooltip')}
              icon="alert"
            />
            <Text.Normal weight="semibold" size="200" color="grey800">
              {i18n.t('teams.working_location')}
            </Text.Normal>
          </Table.HeadCell>
        )}
        {canSeeAggregatedInfo && (
          <Table.HeadCell colSpan={2}>
            <Text.Normal weight="medium" size="200" color="grey800">
              {i18n.t('employees.common.gender_distribution')}
            </Text.Normal>
          </Table.HeadCell>
        )}
        <Table.HeadCell colSpan={1} />
      </Table.Row>
    </Table.Head>
  )
}

export default observer(Header)
